import { render, staticRenderFns } from "./OverviewEditor.vue?vue&type=template&id=2001d5f4"
import script from "./OverviewEditor.vue?vue&type=script&lang=js"
export * from "./OverviewEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports